/**
 * Created by mateo on 5/28/17.
 */
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';

import {Item} from './item';

@Component({
    selector: 'custom-item',
    standalone: false,
    template: `
        <div class="cs-item" [ngClass]="{'cs-item-selected': opt.selected}" *ngIf="opt.visible == true">
            <input class="" #miinput [checked]="opt.selected" (change)="clicked(opt, $event)" type="checkbox"
                   [value]="opt.id"/>
            <!--<label class="cs-chkbox" (click)="miinput.click()">
                <i *ngIf="!item.selected" class="cs-chkbox fa fa-fw fa-square-o"></i>
                <i *ngIf="item.selected" class="cs-chkbox fa fa-fw fa-check-square-o"></i>
            </label>-->
            <label (click)="miinput.click()">{{opt.label}}</label>
            <div class="cs-childs-container">
                <div class="cs-item cs-item-child" *ngFor="let child of opt.childs">
                    <input #michildinput class="" [checked]="child.selected"
                           (change)="clicked(child, $event)" type="checkbox" [value]="child.id"/>
                    <!--<label (click)="michildinput.click()" class="cs-chkbox">
                        <i  class="cs-chkbox fa fa-fw fa-square-o"></i>
                        <i class="cs-chkbox fa fa-fw fa-check-square-o"></i>
                    </label>-->
                    <label (click)="michildinput.click()">{{child.label}}</label>
                </div>
            </div>
        </div>`,
    styles: [`
        .cs-item-selected {

        }
        *{
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
        .cs-childs-container{
            padding-left: 1em;
            margin-bottom: 5px;
        }
        
        .hide{
            display: none;
        }
        
        .cs-chkbox:hover{
            color: dodgerblue;
        }
        /*.cs-item {
            display: flex;
            width: 100%;
        }*/
        .cs-item label {
            font-weight: normal;
            display: initial;
        }
    `]
})

export class CustomItemComponent implements OnInit {
    opt: Item;

    @Input()
    set item(item){
        this.opt = item;
    }

    public id: string;

    @Output() onItemClicked: EventEmitter<any> = new EventEmitter();

    constructor() {
        this.id = 'cs-id';
    }

    public ngOnInit(): any {
    }

    /**
     * Captura el evento click y lo emite.
     *
     * @param {Item} value - Item asociado a la opción seleccionada.
     * @param {object} evt - El evento que desencadeno el método en el elemento asociado.
     */
    clicked(value: Item, evt) {
        if (evt && evt.target && evt.target.type === 'checkbox') {
            let clickObj = {event: {target: evt.target}, selected: evt.target.checked, item: value};
            value.selected = evt.target.checked;
            /*value.visible = !value.selected;*/
            this.onItemClicked.emit(clickObj);
        }
    }
}